var render = function render(){var _vm=this,_c=_vm._self._c;return _c('g',[_c('path',{attrs:{"fill":"none","d":"M0 0H24V24H0z"}}),_c('path',{attrs:{"d":"M21 4v2h-1l-5 7.5V22H9v-8.5L4 6H3V4h18zM6.404 6L11 12.894V20h2v-7.106L17.596 6H6.404z"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }